import Vue from 'vue'
import VueI18n from 'vue-i18n'
import axios from "axios";
import ApplicationEventHub from "../events/applicationEventHub";

Vue.use(VueI18n);

function loadLocalLocaleMessages () {
  const locales = require.context('../locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key)
    }
  });
  return messages
}

export const i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocalLocaleMessages()
});

const loadedLanguages = [];

function setI18nLanguage(locale){
  ApplicationEventHub.changeFrameworkLocale(locale);
}

export const loadLocaleMessages = function (locale) {
  if (loadedLanguages.includes(locale)) {
    setI18nLanguage(locale);
    return Promise.resolve();
  }
  const http = axios.create({baseURL:process.env.VUE_APP_API_ENDPOINT});
  return http.get('/platforms/'+(process.env.VUE_APP_PLATFORM_CODE)+'/nestedtext/'+locale).then((response)=>{
    loadedLanguages.push(locale);
    i18n.setLocaleMessage(locale, response.data);
    setI18nLanguage(locale);
  });
};